<template>
  <el-dialog
    title="直接生成核注清单"
    :visible="true"
    width="90%"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <p>
      {{ order.customerId }} /
      {{ order.inboundOrderId || order.outboundOrderId }}
    </p>
    <el-form v-loading="loading" inline size="small" label-width="120px">
      <el-form-item label="清单类型" required
        ><el-select v-model="form.billType" :disabled="saving">
          <el-option
            v-for="option in billTypes"
            :key="option[0]"
            :value="option[0]"
            :label="option[1]"
          /> </el-select
      ></el-form-item>
      <el-form-item
        v-for="field in enterpriseFields"
        :key="field[0]"
        :label="field[1]"
        required
      >
        <el-select v-model="form[field[0]]" filterable :disabled="saving"
          ><el-option
            v-for="e in enterprises"
            :key="e.enterpriseNid"
            :value="e.enterpriseNid"
            :label="e.enterpriseName"
        /></el-select>
      </el-form-item>
      <el-form-item label="监管方式" required
        ><el-select v-model="form.tradeMode" filterable :disabled="saving"
          ><el-option
            v-for="o in getTradeMode"
            :key="o.value"
            :value="o.value"
            :label="o.value + '-' + o.label"/></el-select
      ></el-form-item>
      <el-form-item label="运输方式" required
        ><el-select v-model="form.transMode" filterable :disabled="saving"
          ><el-option
            v-for="o in getTransMode"
            :key="o.value"
            :value="o.value"
            :label="o.value + '-' + o.label"/></el-select
      ></el-form-item>
      <el-form-item label="账册号" required
        ><el-select
          v-model="form.emsNo"
          data-test="account-book"
          filterable
          placeholder="请选择账册"
          :disabled="saving"
          ><el-option
            v-for="option in getAccountBookList"
            :key="option.value"
            :value="option.value"
            :label="option.label"/></el-select
      ></el-form-item>
      <el-form-item label="起运国代码" required
        ><el-input
          label="起运国代码"
          v-model="form.startShipCountry"
          :disabled="saving"
      /></el-form-item>
      <el-form-item label="关联账册备案号"
        ><el-input
          label="关联账册备案号"
          v-model="form.rltEmsNo"
          :disabled="saving"
      /></el-form-item>
      <el-form-item label="关联清单编号"
        ><el-input
          label="关联清单编号"
          v-model="form.rltInvtNo"
          :disabled="saving"
      /></el-form-item>
    </el-form>
    <el-table :data="items" border>
      <el-table-column prop="itemNo" label="商品料号" min-width="160" />
      <el-table-column label="申报数量" width="180"
        ><template slot-scope="scope">
          <el-input-number
            label="申报数量"
            v-if="kind === 'outbound'"
            v-model="scope.row.quantity"
            :min="1"
            :max="2147483647"
            :precision="0"
            :disabled="saving"
            controls-position="right"
          />
          <span v-else>{{ scope.row.quantity }}</span>
        </template></el-table-column
      >
      <el-table-column label="申报单价" width="180"
        ><template slot-scope="scope"
          ><el-input
            label="申报单价"
            v-model="scope.row.unitPrice"
            :disabled="kind === 'inbound' || saving"/></template
      ></el-table-column>
      <el-table-column label="币种" width="250">
        <template slot="header">
          币种
          <customs-currency-select
            v-if="kind === 'outbound'"
            data-test="batch-currency"
            style="width: 150px; margin-left: 8px;"
            :value="batchCurrency"
            :disabled="saving"
            @input="applyCurrency"
          />
        </template>
        <template slot-scope="scope"
          ><customs-currency-select
            v-model="scope.row.currency"
            :disabled="kind === 'inbound' || saving"/></template
      ></el-table-column>
    </el-table>
    <span slot="footer"
      ><el-button :disabled="saving" @click="close">取消</el-button
      ><el-button
        type="primary"
        data-test="save-hezhu"
        :disabled="!ready"
        :loading="saving"
        @click="save"
        >生成核注</el-button
      ></span
    >
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/warehouseReceipt";
import enterpriseApi from "@/api/DeclareEnterpriseApi";
import CustomsCurrencySelect from "@/components/CustomsCurrencySelect";

export default {
  components: { CustomsCurrencySelect },
  props: { kind: String, order: Object },
  data() {
    return {
      form: {
        billType: "0",
        bizOpCompanyCode: "",
        rcvCompanyCode: "",
        dclCompanyCode: "",
        emsNo: "",
        tradeMode: "",
        transMode: "",
        startShipCountry: "",
        rltEmsNo: "",
        rltInvtNo: ""
      },
      items: [],
      batchCurrency: "",
      enterprises: [],
      loading: true,
      ready: false,
      saving: false,
      error: "",
      enterpriseFields: [
        ["bizOpCompanyCode", "经营企业"],
        ["rcvCompanyCode", "收货企业"],
        ["dclCompanyCode", "申报企业"]
      ],
      billTypes: [
        ["0", "普通清单"],
        ["1", "集报清单"],
        ["3", "先入区后报关"],
        ["4", "简单加工"],
        ["5", "保税展示交易"],
        ["6", "区内流转"],
        ["7", "区港联动"],
        ["8", "保税电商"],
        ["9", "一纳成品内销"]
      ]
    };
  },
  computed: {
    ...mapGetters(["getTradeMode", "getTransMode", "getAccountBookList"])
  },
  async created() {
    try {
      const res = await enterpriseApi.listDeclareEnterprise({
        request: { pageInfo: { pageIndex: 1, pageSize: 100000 } }
      });
      this.enterprises = (res.items || []).filter(
        e => e.enterpriseType === "电商企业"
      );
      const source =
        this.kind === "outbound"
          ? await api.outbound.prepareHezhu(this.order.outboundOrderId)
          : this.order;
      this.items = (source.items || []).map(item => ({ ...item }));
      this.ready = true;
    } catch (error) {
      this.error = "核注资料加载失败，请关闭后重试";
    } finally {
      this.loading = false;
    }
  },
  methods: {
    close() {
      if (!this.saving) this.$emit("close");
    },
    applyCurrency(currency) {
      this.batchCurrency = currency;
      this.items.forEach(item => this.$set(item, "currency", currency));
    },
    async save() {
      if (!this.ready || this.saving) return;
      const required = [
        "billType",
        "emsNo",
        "bizOpCompanyCode",
        "rcvCompanyCode",
        "dclCompanyCode",
        "tradeMode",
        "transMode",
        "startShipCountry"
      ];
      if (required.some(key => !String(this.form[key] || "").trim())) {
        this.error = "请填写完整的核注表头";
        return;
      }
      if (
        !this.items.length ||
        this.items.some(
          item =>
            !Number.isInteger(item.quantity) ||
            item.quantity <= 0 ||
            item.quantity > 2147483647 ||
            !/^\d+(\.\d+)?$/.test(item.unitPrice) ||
            Number(item.unitPrice) <= 0 ||
            !item.currency
        )
      ) {
        this.error = "请填写正整数数量、正数单价和币种";
        return;
      }
      this.saving = true;
      this.error = "";
      try {
        const request = { ...this.form };
        if (this.kind === "inbound")
          request.inboundOrderId = this.order.inboundOrderId;
        else {
          request.outboundOrderId = this.order.outboundOrderId;
          request.items = this.items.map(
            ({ itemNo, quantity, unitPrice, currency }) => ({
              itemNo,
              quantity,
              unitPrice,
              currency
            })
          );
        }
        const res = await api[this.kind].createHezhu(request);
        if (!res || !res.value) throw new Error("生成未返回核注号");
        this.$emit("saved");
      } catch (error) {
        this.error = error.msg || error.message || "生成失败，请刷新后确认结果";
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
